<template>
  <div class="work-order-process d-flex justify-content-center align-items-center">
    <template v-for="(processInfo,index) in processDurationList">
      <div :key="'line-'+index" v-if="index>0" class="d-flex flex-column duration-container">
        <div
          class="process-duration text-warning"
        >{{Number.isInteger(processInfo.timeSpan)?
        `${parseInt(processInfo.timeSpan,10)}min`:"&nbsp;"}}</div>
        <div class="process-line"
        :class="processInfo.F_CreateDate?'line-solid':'line-dashed'"></div>
      </div>
      <process-item
        @activeProcess="activeProcessListener(index)"
        :key="'step-'+index"
        :isActive="processIndex === parseInt(index,10)"
        :processInfo="processInfo"
      ></process-item>
    </template>
  </div>
</template>
<script>
import ProcessItem from '@/components/equipment-operational/components/work-detail/process-item.vue';

export default {
  name: 'work-order-process',
  props: {
    processIndex: {
      type: Number,
      default: 0,
    },
    processList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {
    ProcessItem,
  },
  watch: {

  },
  mounted() {

  },
  computed: {
    processDurationList() {
      const arr = [];
      for (let i = 0; i < this.processList.length; i += 1) {
        const item = this.processList[i];
        if (i > 0) {
          const prev = this.processList[i - 1];
          item.timeSpan = Math.round((Date.parse(item.F_CreateDate)
           - Date.parse(prev.F_CreateDate)) / 1000 / 60);
        }
        arr.push(item);
      }
      return arr;
    },
  },
  methods: {
    activeProcessListener(index) {
      this.$emit('update:processIndex', index);
    },
  },
};
</script>
<style scoped>
.finished-process {
  background-color: #409EFF;
}
.process+.process{
  position: absolute;
  content:" ";
  width: 100%;
  height: 5px;
}
.process-line {
  width: 6rem;
  border-top-width: thin;
}
.process-duration {
  font-size: 12px;
  line-height: 12px;
  height:12px;
}
.duration-container{
  margin-top:-26px
}
.line-solid{
  border-top-style: solid;
  border-top-color: #409EFF;
}
.line-dashed{
  border-top-style: dashed;
  border-top-color: gray;
}
</style>
